import * as React from 'react';
import * as moment from  'moment';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Schedule.css';
import 'moment/locale/fr';
import { TableChorinitia } from '../../genericComponents/TableChorinitia/TableChorinitia';
import { ListeEvent } from './ListeEvent';
import * as ReqType from '../../../types/ServerRequests';
import { EventService } from '../../../services/EventService';

export interface Props {
    title: string;
}

/**
 * Ce composant permet d'afficher le planning
 *
 */
export class Schedule extends React.Component {
    props: Props;
    /**
     *
     * date: Date; today: moment.Moment;
     * showMonthPopup: boolean;
     * showYearPopup: boolean; showYearNav: boolean;
     * selectedDay: null; listEvent: any[]}}
     */
    state = {
        dateContext: moment(),
        date: moment().toDate(),
        today: moment(),
        showMonthPopup: false,
        showYearPopup: false,
        showYearNav: false,
        selectedDay: null,
        listEvent: [],
    };
    private event?: ReqType.Event ;

    /**
     *
     * @param {Props} props
     */
    constructor(props: Props) {
        super(props);

        EventService.getInstance().getEvents().then(
            (resp: ReqType.Event[]) => {
                this.setState({listEvent: resp});
            }
        ).catch(
            () => alert('Le service marche pas')
        );

    }

    /**
     *
     * @returns {string[]}
     */
    weekdays = () => {
        return  moment.weekdays();
    }
    /**
     *
     * @returns {string[]}
     */
    weekdaysShort = () => {
        return  moment.weekdaysShort();
    }
    /**
     *
     * @returns {string[]}
     */
    months = () => {
        return moment.months();
    }
    /**
     *
     * @returns {string}
     */
    year = () => {
        return this.state.dateContext.format('Y');
    }
    /**
     *
     * @returns {string}
     */
    month = () => {
        return this.state.dateContext.format('MMM');
    }
    /**
     *
     * @returns {number}
     */
    daysInMonth = () => {
        return this.state.dateContext.daysInMonth();
    }
    /**
     *
     * @returns {number}
     */
    currentDate = () => {
        // alert('currentDate: ' + this.state.dateContext.get('date'));
        return this.state.dateContext.get('date');
    }
    /**
     *
     * @returns {number}
     */
    currentDay = () => {
        let currentDayString = this.state.dateContext.format('D');
        let currentDay: number = +currentDayString;
        return currentDay;
    }
    /**
     *
     * @returns {number}
     */
    firstDayOfMonth = () => {
        let dateContext = this.state.dateContext;
        let firstDayS = moment(dateContext).startOf('month').format('d'); // Day of week 0...1..5...6
        let firstDay: number = +firstDayS;
        return firstDay;
    }

    /**
     * changer de mois
     * @param {string} month
     */
    setMonth = (month: string) => {
        let monthNo: number = this.months().indexOf(month);
        let dateContext = Object.assign({}, this.state.dateContext);
        dateContext = moment(dateContext).set('month', monthNo);
        this.setState({dateContext: dateContext});
    }

    /**
     *
     */
    nextMonth = () => {
        // alert(this.state.date);
        let dateContext = Object.assign({}, this.state.dateContext);
        dateContext = moment(dateContext).add(1, 'month');
        this.setState({
            dateContext: dateContext,
        });
    }
    /**
     *
     */
    prevMonth = () => {
        // alert(this.state.date);
        let dateContext = Object.assign({}, this.state.dateContext);
        dateContext = moment(dateContext).subtract(1, 'month');
        this.setState({
            dateContext: dateContext,
        });
    }

    /**
     * selectionner pour changer de mois
     * @param {string} data
     */
    onSelectChange = (data: string) => {
        this.setMonth(data);
        // this.props.onMonthChange && this.props.onMonthChange();
    }

    /**
     * selectionner un element dans la liste du mois
     * @param {string[]} data
     * @returns {any}
     * @constructor
     */
    SelectList = (data: string[]) => {
        let popup = data.map ((m) => {
            return (
                <div key={m}>
                    <a
                        className="dropdown-item"
                        href="#"
                        onClick={(e) => {this.onSelectChange(m); }}
                    >
                        {m}
                    </a>
                </div>
            );
        });

        return (
            <div className="month-popup">
                {popup}
            </div>
        );
    }

    /**
     * changer de mois
     */
    onChangeMonth = () => {
        this.setState({showMonthPopup: !this.state.showMonthPopup
        });
    }

    /**
     * naviguer dans les mois yes
     * @returns {any}
     * @constructor
     */
    MonthNav = () => {
        let Data: string[] = this.months();
        return (
            <span
                className="label-month"
                onClick={this.onChangeMonth}
            >
                {this.month()}
                {
                    this.state.showMonthPopup &&
                    this.SelectList(Data)
                }
            </span>
        );
    }
    /**
     *
     */
    showYearEditor = () => {
        this.setState({showYearNav: true});
    }
    /**
     * modifier l'année
     * @param {string} year
     */
    setYear = (year: string) => {
        let dateContext = Object.assign({}, this.state.dateContext);
        dateContext = moment(dateContext).set('year', +year);
        this.setState({
            dateContext: dateContext,
        });
    }
    /**
     *
     * @param {React.ChangeEvent<HTMLInputElement>} e
     */
    onYearChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setYear(e.target.value);
        // this.onYearChange && this.onYearChange(e);
    }

    /**
     * naviguer dans le mois
     * @returns {any}
     * @constructor
     */
    YearNav = () => {
        return (
            this.state.showYearNav ?
                (
                    <input
                        defaultValue={this.year()}
                        className="editor-year"
                        ref={(yearInput) => {yearInput = yearInput; }}
                        onChange={(e) => this.onYearChange(e)}
                        type="number"
                        placeholder="year"
                    />)
                :
                (
                    <span
                        className="label-year"
                        onClick={(e) => {this.showYearEditor(); }}
                    >
                        {this.year()}
                    </span>
                )
        );
    }

    Mousse = () => {
        // alert('cc');
    }
    /**
     *
     * @param {number} day
     */
    onDayClick = (day: number) => {
        this.state.date.setUTCFullYear( this.state.dateContext.toDate().getUTCFullYear());
        this.state.date.setMonth(this.state.dateContext.toDate().getUTCMonth());
        this.state.date.setDate(day);
        // alert(  this.state.date.toLocaleDateString() );
        this.setState({date: this.state.date});
    }

    /**
     * le rendu calendrier
     * @returns {any}
     */
    render() {
        const divStyle = {
            cursor: 'pointer'
        };

        // affichage des jours en format cours
        let weekdays = this.weekdaysShort().map((day) => {
            return (
                <td key={day} className="week-day"><strong>{day}</strong></td>
            );
        });

        // affiche du blanc pour les jours qui sont pas dans le mois
        let ind: number = 0; // indice des elements dans le tableau
        let tab = []; // tableau de base
        let tabrow = []; // tableau du mois avec retour a la ligne

        // affichage du blanc pour les jours du mois qui ne sont pas dans la semaine
        for (let i = 0; i < this.firstDayOfMonth(); i++) {
            tab.push((
                <td
                    key={ind}
                    className="emptySlot"
                >
                    {''}
                </td>));
            ind++;
        }

        // ajout des jours de la semaine a la tableau tabRow
        for (let d = 1; d < this.daysInMonth() + 1; d++) { // this.dayInMonth() + 1 pour traité le dernier jour

            this.event = this.state.listEvent.find(
                (e: ReqType.Event) => {
                    return ((e.date_heure_debut.getDate() === d) &&
                        (e.date_heure_debut.getMonth() === this.state.dateContext.toDate().getMonth()) &&
                        (e.date_heure_debut.getUTCFullYear() === this.state.dateContext.toDate().getUTCFullYear()));
                }
            );

            let currentEvent: ReqType.Event;

            let jour: JSX.Element = <p/>;

            let className = () => {return 'day'; };

            if (this.event !== undefined) {
                currentEvent = this.event;
                jour = (
                        <p> {d.toString()}
                            <span className="badge badge-secondary badge-pill align-top float-right">
                                <strong> {currentEvent.intitule} </strong>
                            </span>
                        </p>);

                className = () => {
                    if ((this.state.date.getDate() === d) &&
                        (this.state.date.getMonth() === this.state.dateContext.toDate().getMonth()) &&
                        (this.state.date.getUTCFullYear() === this.state.dateContext.toDate().getUTCFullYear())) {
                        return 'day event-current';
                    } else if (this.currentDay() === d &&
                        (this.state.dateContext.toDate().getMonth() === this.state.today.toDate().getMonth()) &&
                        (this.state.dateContext.toDate().getUTCFullYear() ===
                            this.state.today.toDate().getUTCFullYear())) {
                        return 'day current-day';
                    } else if ((currentEvent.date_heure_debut.getDate() === d) &&
                        (currentEvent.date_heure_debut.getMonth() === this.state.dateContext.toDate().getMonth()) &&
                        (currentEvent.date_heure_debut.getUTCFullYear() ===
                            this.state.dateContext.toDate().getUTCFullYear())) {
                        return 'day event-day';
                    } else {
                        return 'day';
                    }
                };
            } else {
                className = () => {
                    if ((this.state.date.getDate() === d) &&
                        (this.state.date.getMonth() === this.state.dateContext.toDate().getMonth()) &&
                        (this.state.date.getUTCFullYear() === this.state.dateContext.toDate().getUTCFullYear())) {
                        return 'day event-current';
                    } else if (this.currentDay() === d &&
                        (this.state.dateContext.toDate().getMonth() === this.state.today.toDate().getMonth()) &&
                        (this.state.dateContext.toDate().getUTCFullYear() ===
                            this.state.today.toDate().getUTCFullYear())) {
                        return 'day current-day';
                    } else {
                        return 'day';
                    }
                };
                jour = <p> {d.toString()} </p>;
            }

            if (( ind % 7 ) !== 0) {

                tab.push(
                    <td
                        key={ind}
                        className={className()}
                        onClick={() => {
                            this.onDayClick(d); }
                        }
                        onMouseOver={() => {this.Mousse(); }}
                    >
                        <strong>
                            <span>
                                {jour}
                            </span>
                        </strong>
                    </td>
                );
            } else {
                let inserRow = tab.slice();
                tabrow.push(inserRow);
                tab = [];
                tab.push(
                    <td
                        key={ind}
                        className={className()}
                        onClick={() => {
                            this.onDayClick(d); }
                        }
                        onMouseOver={() => {this.Mousse(); }}
                    >
                        <strong>
                            <span>
                                {jour}
                            </span>
                        </strong>
                    </td>
                );
            }
            if (d === this.daysInMonth() ) {
                let insertRow = tab.slice();
                tabrow.push(insertRow);
            }
            ind++;
        }

        // ajout des semaines du mois à la table trElement
        let trElems = tabrow.map((d , i) => {
            return(
                <tr key={i * 100}>
                    {d}
                </tr>
            );
        });

        return (
            <div>
                <div className="card card-default">
                    <div className="card-header col-12">
                        <h4 className="text-white offset-3">
                            <strong>
                                Calendrier des animations CHOR'INITIA
                                {' ' + this.state.today.toDate().getUTCFullYear() + ' - '}
                                {this.state.today.toDate().getUTCFullYear() + 1}
                            </strong>
                        </h4>
                    </div>
                    <div className="card-body">
                <div className="calendar-container ">
                    <h1 className=" align-content-center">
                        {this.props.title}
                    </h1>
                    <TableChorinitia
                        header={
                            <thead>
                                <tr className="calendar-header">
                                        <th
                                            scope="col"
                                            className=""
                                            onClick={() => {
                                                this.prevMonth();
                                            }}
                                        >
                                            <i
                                                className="prev fa fa-fw fa-chevron-left"
                                                style={divStyle}
                                            />
                                        </th>
                                        <th scope="col" colSpan={3} className="align-content-center" style={divStyle}>
                                                <this.MonthNav />
                                        </th>
                                        <th scope="col" colSpan={2} className="align-content-center" style={divStyle}>
                                                <this.YearNav/>
                                        </th>

                                        <th
                                            scope="col"
                                            className="align-content-center"
                                            onClick={() => {
                                                this.nextMonth();
                                            }}
                                            style={divStyle}
                                        >
                                            <i
                                                className="prev fa fa-fw fa-chevron-right offset-9"
                                                style={divStyle}
                                            />
                                        </th>
                                </tr>
                            </thead>
                        }
                    >
                        <tbody>
                        <tr>
                            {weekdays}
                        </tr>
                        {trElems}
                        </tbody>
                    </TableChorinitia>
                </div>
                    </div>
                </div>
                <div>
                    <br/>
                    <div className="card card-default">
                        <div className="card-header col-12">
                            <h4 className="text-white offset-4">
                                <strong> Les Evènements du {' ' + this.state.date.toLocaleDateString()} </strong>
                            </h4>
                        </div>

                        <div className="card-body">
                            <ListeEvent date={this.state.date} />
                        </div>
                    </div>
                </div>

            </div>);
    }
}

// table-striped table-dark


// WEBPACK FOOTER //
// ./src/components/SchedulePage/internalComponents/Schedule.tsx